export const gojsAttentionCursor = `url(/assets/cursors/attention.svg) 9 8, crosshair`;
export const gojsCommentCursor = `url(/assets/cursors/chat-cloud.svg) 0 0, copy`;
export const gojsPenCursor = `url(/assets/cursors/pen.svg) 0 18, crosshair`;
export const gojsStickyNoteCursor = `url(/assets/cursors/sticky.svg) 0 0, crosshair`;
